import { render, staticRenderFns } from "./RegisterProcessFromAnonymous.vue?vue&type=template&id=7081b3a8&scoped=true&"
import script from "./RegisterProcessFromAnonymous.vue?vue&type=script&lang=js&"
export * from "./RegisterProcessFromAnonymous.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProcessFromAnonymous.vue?vue&type=style&index=0&id=7081b3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081b3a8",
  null
  
)

export default component.exports